<template>
  <div>
    {{ getProperDataForDisplayStatusChange() }}
  </div>
</template>

<script>
import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js'

export default {
  name: 'DisplayStatusChangeRenderer',
  props: {
    eventType: {
      type: String,
      required: true,
    },
    eventData: {
      type: String,
      required: true,
    }
  },
  methods: {
    getProperDataForDisplayStatusChange() {
        const onlineStatus = erm.getValueOutOfGivenKey('onlineStatus', this.eventData);
        let resultString = erm.getTranslationForEventDescription(this.eventType);
        if (!onlineStatus || !resultString) {
            return this.eventData;
        }
        resultString += onlineStatus;
        return resultString;
    },
  }
};
</script>